$(document).ready(function () {
    var $sticky = $(".sticky-cta");
    var stickyOffsetBottom;

    removeScrollLimit();
    init();
    
    $(window).on("resize", function () {
        init();
    });
    
    function init() {
        addStickyFlagToContentWrapper();
        stickyOffsetBottom = 0;
        handleStickyScrolling(stickyOffsetBottom);
    }

    function addStickyFlagToContentWrapper() {
        if ($sticky.length > 0) {
            $("body").addClass("has-sticky");
        }
    }

    function handleStickyScrolling(offsetBottom) {
        $(window).on("scroll", (function () {
            $(window).scrollTop() + $(window).height() > $("footer").offset().top + 13 ? addScrollLimit() : removeScrollLimit();
        }));
    }

    //Helper Functions
    function removeScrollLimit() {
        $sticky.css({
            position: "",
            bottom: 0 + "px"
        });
    }

    function addScrollLimit() {
        $sticky.css({
            position: "absolute",
            bottom: $("footer").outerHeight() - 13 + "px"
        });
    }


})